import { confirmSignUp, getCurrentUser, signUp } from "aws-amplify/auth";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const [form, setForm] = useState({ username: "", password: "", code: "" });
  const [step, setStep] = useState("register"); // 'register' | 'verify'
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await getCurrentUser();   // SAFE call
        navigate("/");            // user is logged in
      } catch {
        // user is NOT logged in → stay on login page
      }
    };

    checkAuth();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);

    try {
      await signUp({
        username: form.username,
        password: form.password,
        options: {
          userAttributes: {
            email: form.username,
          },
        },
      });
      
      setMessage(
        "Your account has been created and is pending admin approval. Once approved, you can login! Send an email for the expedited approval, admin@regulify.ai",
      );
      setStep("verify");
    } catch (err) {
      console.error(err);
      setError(err.message || "Registration failed.");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);

    try {
      await confirmSignUp({
        username: form.username,
        confirmationCode: form.code,
      });

      setMessage("Email verified! Redirecting to login...");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      console.error(err);
      setError(err.message || "Verification failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-base-200 flex min-h-screen items-center justify-center px-4">
      <div className="card bg-base-100 w-full max-w-md shadow-xl">
        <div className="card-body">
          <h2 className="card-title justify-center text-2xl">Register</h2>

          {error && <div className="alert alert-error text-sm">{error}</div>}
          {message && <div className="alert alert-info text-sm">{message}</div>}

          <form onSubmit={handleRegister} className="space-y-4">
            <input
              type="email"
              name="username"
              placeholder="Email"
              className="input input-bordered w-full"
              onChange={handleChange}
              required
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              className="input input-bordered w-full"
              onChange={handleChange}
              required
            />
            <button
              type="submit"
              className="btn btn-primary w-full"
              disabled={loading}
            >
              {loading ? "Registering..." : "Register"}
            </button>
          </form>

          <p className="mt-4 text-center text-sm">
            Already have an account?{" "}
            <a href="/login" className="link link-primary">
              Login
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
